import request from '@/utils/request'

// 添加券分类
export function addCouponClassification(data) {
  return request({
    url: '/coupon/addClassification',
    method: 'post',
    data
  })
}

//   获取一级分类
export function getFirstNameList(data) {
  return request({
    url: '/coupon/getFirstNameList',
    method: 'get',
    params: data
  })
}


//   配置领券打卡
export function configCouponClock(data) {
  return request({
    url: '/coupon/configCouponClock',
    method: 'post',
    data
  })
}


//   获取分类配置列表
export function getClassList(data) {
  return request({
    url: '/coupon/getClassList',
    method: 'get',
    params: data
  })
}

//   添加分类
export function addClassification(data) {
  return request({
    url: '/coupon/addClassification',
    method: 'post',
    data
  })
}

//   删除分类
export function deleteClassification(data) {
  return request({
    url: '/coupon/deleteClassification',
    method: 'post',
    data
  })
}

//   编辑分类
export function updateClassification(data) {
  return request({
    url: '/coupon/updateClassification',
    method: 'post',
    data
  })
}

//   分页查询优惠券列表
export function getTemplateList(data) {
  return request({
    url: '/coupon/getTemplateList',
    method: 'post',
    data
  })
}

//  获取分类详情
export function getOneClassification(data) {
  return request({
    url: '/coupon/getOneClassification',
    method: 'get',
    params: data
  })
}

//  配置领券打卡获取详情
export function getConfigCouponClock(data) {
  return request({
    url: '/coupon/getConfigCouponClock',
    method: 'get',
    params: data
  })
}

// 查询商品列表
export function listProduct(data) {
  return request({
    url: '/coupon/listProduct',
    method: 'post',
    data
  })
}
// 查询医生列表
export function listDoctor(data) {
  return request({
    url: '/coupon/listDoctor',
    method: 'get',
    params: data
  })
}
// 查询优惠券商品列表
export function listCouponProducts(data) {
  return request({
    url: '/coupon/listCouponProducts',
    method: 'get',
    params: data
  })
}
// 查询优惠券医生列表
export function listCouponDoctor(data) {
  return request({
    url: '/coupon/listCouponDoctor',
    method: 'get',
    params: data
  })
}
// 按分类查询商品列表
export function getProductListByCategoryIds(data) {
  return request({
    url: '/coupon/queryClassificationList',
    method: 'post',
    data
  })
}

// 按券模板查询商品列表
export function getcouponProductList(data) {
  return request({
    url: 'coupon/selectCouponProductList',
    method: 'post',
    data
  })
}

// 分页查询商城商品列表
export function queryMallProductList(data) {
  if(data.productIdList == ''){
    data.productIdList = null
  }
  return request({
    url: '/newMall/couponv2/queryMallProductList',
    method: 'post',
    data
  })
}

// 查询商城商品列表
export function queryMallProductListAll(data) {
  if(data.productIds == ''){
    data.productIds = null
  }
  return request({
    url: '/newMall/productChannelNew/query/productIds',
    method: 'post',
    data
  })
}

// 批量新增不参与券活动商品
export function batchAddExcludeProduct(data) {
  return request({
    url: '/newMall/couponv2/batchAddExcludeProduct',
    method: 'post',
    data
  })
}

// 新增优惠券
export function newMalladdCoupon(data) {
  return request({
    url: '/newMall/couponv2/addCoupon',
    method: 'post',
    data
  })
}

// 查询优惠券列表
export function queryCouponList(data) {
  return request({
    url: '/newMall/couponv2/queryCouponList',
    method: 'get',
    data
  })
}

// 查询定时发放活动可用的优惠券
export function querySendCouponCoupons(data) {
  return request({
    url: '/newMall/couponv2/querySendCouponCoupons',
    method: 'get',
    data
  })
}

// 查询签收活动可用的优惠券
export function querySignReceiveCoupons(data) {
  return request({
    url: '/newMall/couponv2/querySignReceiveCoupons',
    method: 'get',
    data
  })
}

// 查询优惠详情
export function queryCouponDetail(data) {
  return request({
    url: '/newMall/couponv2/queryCouponDetail',
    method: 'get',
    data
  })
}

// 查询不参与券活动商品列表
export function queryExcludeProductList(data) {
  return request({
    url: '/newMall/couponv2/queryExcludeProductList',
    method: 'get',
    data
  })
}

// 修改优惠券
export function modifyCoupon(data) {
  return request({
    url: '/newMall/couponv2/modifyCoupon',
    method: 'post',
    data
  })
}

// 启用优惠券
export function enableCoupon(data) {
  return request({
    url: `/newMall/couponv2/enableCoupon?id=${data.id}`,
    method: 'post',
  })
}

// 暂停优惠券
export function pauseCoupon(data) {
  return request({
    url: `/newMall/couponv2/pauseCoupon?id=${data.id}`,
    method: 'post',
  })
}

// 禁用不参与券活动商品
export function disableExcludeProduct(data) {
  return request({
    url: `/newMall/couponv2/disableExcludeProduct?id=${data.id}`,
    method: 'post',
  })
}

// 启用不参与券活动商品
export function enableExcludeProduct(data) {
  return request({
    url: `/newMall/couponv2/enableExcludeProduct?id=${data.id}`,
    method: 'post',
  })
}

// 批量启用不参与券活动商品
export function batchEnableExcludeProduct(data) {
  return request({
    url: '/newMall/couponv2/batchEnableExcludeProduct',
    method: 'post',
    data
  })
}

// 批量禁用不参与券活动商品
export function batchDisableExcludeProduct(data) {
  return request({
    url: '/newMall/couponv2/batchDisableExcludeProduct',
    method: 'post',
    data
  })
}

// 批量导入不参与券活动商品列表
export function batchImportExcludeProductList(data) {
  return request({
    url: '/newMall/couponv2/batchImportExcludeProductList',
    consumes: 'multipart/form-data',
    method: 'post',
    data
  })
}

// 批量导券管理列表获取
export function querybatchGuideList(data) {
  return request({
    url: '/newMall/couponv2/sc/query/page',
    method: 'get',
    data
  })
}

// 批量导券管理详情查询
export function querybatchGuideListByid(data) {
  return request({
    url: '/newMall/couponv2/sc/query',
    method: 'get',
    data
  })
}

// 停止发放优惠券
export function stopbatchGuideListByid(data) {
  return request({
    url: '/newMall/couponv2/sc/stop',
    method: 'post',
    data
  })
}

// 批量导券管理新增
export function batchGuideListAdd(data) {
  return request({
    url: '/newMall/couponv2/sc/add',
    method: 'post',
    data
  })
}

// 批量导券管理上传excel
export function batchGuideListUpload(data) {
  return request({
    url: '/newMall/couponv2/sc/user-file/upload/excel',
    method: 'post',
    consumes: "multipart/form-data",
    data
  })
}

// 批量导券管理上传excel
export function batchGuideListUpdateById(data) {
  return request({
    url: '/newMall/couponv2/sc/update',
    method: 'post',
    data
  })
}


// 用户签收奖励获取列表数据
export function firstActivityList(data) {
  return request({
    url: '/newMall/couponv2/sr/query/page',
    method: 'get',
    data
  })
}

// 用户签收奖励新增
export function firstActivityAdd(data) {
  return request({
    url: '/newMall/couponv2/sr/add',
    method: 'post',
    data
  })
}

// 用户签收根据id查看详情
export function firstActivityqueryById(data) {
  return request({
    url: '/newMall/couponv2/sr/query',
    method: 'get',
    data
  })
}

// 用户签收根据id修改数据
export function firstActivityupdateById(data) {
  return request({
    url: '/newMall/couponv2/sr/update',
    method: 'post',
    data
  })
}

// 用户签收列表状态开启
export function firstActivityStartById(data) {
  return request({
    url: `/newMall/couponv2/sr/start?id=${data.id}`,
    method: 'post',
  })
}

// 用户签收 列表状态暂停
export function firstActivityPauseById(data) {
  return request({
    url: `/newMall/couponv2/sr/pause?id=${data.id}`,
    method: 'post',
  })
}

// 用户签收 解析短信模板内容
export function parseSmsTemplate(data) {
  return request({
    url: `/newMall/couponv2/sr/parseSmsTemplate`,
    method: 'post',
    data
  })
}

// 商品说明 查询商品说明书列表
export function getProductManualList(data) {
  return request({
    url: `/newMall/product/getProductManualList`,
    method: 'get',
    data
  })
}

// 商品说明 修改商品说明书
export function updateProductManual(data) {
  return request({
    url: `/newMall/product/updateProductManual`,
    method: 'post',
    data
  })
}

// 商品说明 导入商品说明书
export function importProductManual(data) {
  return request({
    url: `/newMall/product/importProductManual`,
    method: 'post',
    data
  })
}

// 商品说明 导出商品说明书
export function exportProductManual(data) {
  return request({
    responseType: 'blob',
    url: `/newMall/product/exportProductManual`,
    method: 'get',
    data
  })
}

// 日志接口
export function operatorlogList(data) {
  return request({
    url: `/operatorlog/list`,
    method: 'get',
    data
  })
}


// 查询商品缺货登记列表
export function queryProductOutStockRegList(data) {
  return request({
    url: '/newMall/product/productOutStockReg/queryProductOutStockRegList',
    method: 'post',
    data
  })
}

// 查询商品缺货登记用户列表
export function queryProductOutStockRegUserList(data) {
  return request({
    url: '/newMall/product/productOutStockReg/queryProductOutStockRegUserList',
    method: 'post',
    data
  })
}

// 批量发送到货通知
export function batchSendRestockNotice(data) {
  return request({
    url: '/newMall/product/productOutStockReg/batchSendRestockNotice',
    method: 'post',
    data
  })
}

// 批量导出缺货登记列表
export function productOutStockRegExport(data) {
  return request({
    responseType: 'blob',
    url: '/newMall/product/productOutStockReg/export',
    method: 'post',
    data
  })
}

// 【自营商城】导入数据日志，分页查询
export function importdataquery(data) {
  return request({
    url: '/newMall/import/data/log/query/page',
    method: 'get',
    data
  })
}

// 【自营商城】批量修改商品
export function productChannelNewUpdateBatch(data) {
  return request({
    url: '/newMall/productChannelNew/update/product/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量修改用药贴士
export function productChannelNewMedicationTipsBatch(data) {
  return request({
    url: '/newMall/productChannelNew/update/medicationTips/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量修改价格
export function productChannelNewPriceBatch(data) {
  return request({
    url: '/newMall/productChannelNew/update/price/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量修改图片
export function productChannelNewImageBatch(data) {
  return request({
    url: '/newMall/productChannelNew/update/image/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量修改图片
export function productChannelNewImagesBatch(data) {
  return request({
    url: '/newMall/productChannelNew/update/images/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量新增商品
export function importProductChannel(data) {
  return request({
    url: 'newMall/productChannel/importProductChannel',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】批量修改可开发状态
export function productChannelchangeDevelopStatus(data) {
  return request({
    url: '/newMall/productChannelNew/update/developStatus/batch',
    consumes: 'multipart/form-data',
    method: 'POST',
    data
  })
}

// 【自营商城】优惠券数据
export function queryCouponDetailList(data) {
  return request({
    url: '/newMall/couponv2/queryCouponDetailList',
    method: 'get',
    data
  })
}

// 【自营商城】导出优惠券数据
export function exportCouponDetailList(data) {
  return request({
    responseType: 'blob',
    url: '/newMall/couponv2/exportCouponDetailList',
    method: 'get',
    data
  })
}

// 【自营商城】导出不可用券商品
export function exportExcludeProductList(data) {
  return request({
    responseType: 'blob',
    url: '/newMall/couponv2/exportExcludeProductList',
    method: 'get',
    data
  })
}

// 【自营商城】查询导入结果
export function productChannelNewImportResult(data) {
  return request({
    responseType: 'blob',
    url: '/newMall/productChannelNew/import/result',
    method: 'get',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/shop/couponManage.js